import { Component, OnInit } from '@angular/core';
import { GeneralSettingsService } from '../../Services/general-settings.service';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-member-whatsapp-community',
  template: require('./member-whatsapp-community.component.html'),
  styles: [require('./member-whatsapp-community.component.css')]
})
export class MemberWhatsAppCommunityComponent implements OnInit {
 

  constructor(private auth:AuthService) { }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/member-whatsapp-community/member-whatsapp-community.ts